export const mapPendingOrderAdressToAddress = (pendingOrderAddress: any) => {
  delete pendingOrderAddress['deliveryPrice'];
  return pendingOrderAddress;
};
